import { API_URL } from "config";
import Http from "util/https";
import { CSVUploadCountParam, CSVUploadCountResponseApi } from "../types";

/**
 * CSVアップロードを反映
 * @param params 仕入先コード
 */
export default async function uploadCountCsvApi(
  params: {process_id: string},
): Promise<CSVUploadCountResponseApi> {
  console.log('uploadCountCsvApi params:', params);
  // const { code, limit, csv_file: csvFile } = params;
  const http = Http.default.alterAuth({ useToken: true });

  const url = `${API_URL}/joyful/item/csv/regist`;
  // const formatDate = Http.convertObjectToFormData(params);
  const res = await http.post<CSVUploadCountResponseApi>(url, params);
  console.log(res);

  // Mockデータ
  // const res = {
  //   process_id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  //   total: 9999,
  //   managed_items: [
  //     {
  //       item_cd: "123456",
  //       jan_cd: "1234567890123",
  //       class_name: "タイヤ",
  //       vendor_name: "bbbb",
  //       brand: "ﾎﾟﾃﾝｻﾞ",
  //       item_name: "ﾎﾟﾃﾝｻﾞRE77",
  //       size: "195R17",
  //       store_wholesale_price: 9999,
  //     },
  //   ],
  // };

  return res.data;
}
